var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import Button from '../../button/button';
import InputGroup from '../inputgroup/inputgroup';
var SimInputGroup = /** @class */ (function (_super) {
    __extends(SimInputGroup, _super);
    function SimInputGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            var value = e.currentTarget.value;
            var numbersOnly = /^[0-9]*$/;
            if (numbersOnly.test(value)) {
                _this.setState({ sim: value });
            }
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            var sim = _this.state.sim;
            var submitAction = _this.props.submitAction;
            submitAction(sim);
            _this.setState({ sim: '' });
        };
        _this.state = {
            sim: '',
        };
        return _this;
    }
    SimInputGroup.prototype.render = function () {
        var _a = this.props, innerRef = _a.innerRef, placeholder = _a.placeholder;
        var sim = this.state.sim;
        var validSimLength = sim.length <= 19 && sim.length >= 18;
        return (React.createElement("div", { className: "SimInputGroup" },
            React.createElement("form", { onSubmit: this.handleSubmit },
                React.createElement(InputGroup, { innerRef: innerRef, name: "sim", type: "text", value: sim, placeholder: placeholder, onChange: this.handleChange, classes: validSimLength && 'SimInputGroup--valid' }),
                React.createElement(Button, { classes: "SimInputGroup__button", type: "secondary", small: true, disabled: !validSimLength }, "Add"))));
    };
    return SimInputGroup;
}(React.Component));
export default forwardRef(function (props, ref) { return (React.createElement(SimInputGroup, __assign({}, props, { innerRef: ref }))); });
